import script from "./build-sprint-project-review.vue?vue&type=script&setup=true&lang=ts"
export * from "./build-sprint-project-review.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__